import { Tooltip } from '@zillow/constellation-10';

interface QuestionMarkIconToolTipProps {
  content: React.ReactNode;
}

export const QuestionMarkIconToolTip = (props: QuestionMarkIconToolTipProps) => <Tooltip>{props.content}</Tooltip>;
